import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "../../utils/asyncActions";
import {
  ADMIN_CREATE_BLOCK_REQUEST,
  ADMIN_CREATE_BLOCK_SUCCESS,
  ADMIN_CREATE_BLOCK_FAILURE,
  ADMIN_UPDATE_BLOCK_REQUEST,
  ADMIN_UPDATE_BLOCK_SUCCESS,
  ADMIN_UPDATE_BLOCK_FAILURE,
  ADMIN_DELETE_BLOCK_REQUEST,
  ADMIN_DELETE_BLOCK_SUCCESS,
  ADMIN_DELETE_BLOCK_FAILURE,
} from "../adminConstants";

type createBlockParams = Parameters<typeof ApiService.createAdminBlock>[0];
type updateBlockParams = Parameters<
  typeof ApiService.partialUpdateAdminBlock
>[0];
type deleteBlockParams = Parameters<typeof ApiService.destroyAdminBlock>[0];

export const createBlock = createAsyncSaga(
  ADMIN_CREATE_BLOCK_REQUEST,
  ADMIN_CREATE_BLOCK_SUCCESS,
  ADMIN_CREATE_BLOCK_FAILURE,
  () => "admin/blocks/create",
  ApiService.createAdminBlock,
  { skipErrorToast: true }
) as AsyncSagaAction<createBlockParams>;

export const updateBlock = createAsyncSaga(
  ADMIN_UPDATE_BLOCK_REQUEST,
  ADMIN_UPDATE_BLOCK_SUCCESS,
  ADMIN_UPDATE_BLOCK_FAILURE,
  () => "admin/blocks/update",
  ApiService.partialUpdateAdminBlock,
  { skipErrorToast: true }
) as AsyncSagaAction<updateBlockParams>;

export const deleteBlock = createAsyncSaga(
  ADMIN_DELETE_BLOCK_REQUEST,
  ADMIN_DELETE_BLOCK_SUCCESS,
  ADMIN_DELETE_BLOCK_FAILURE,
  () => "admin/blocks/delete",
  ApiService.destroyAdminBlock
) as AsyncSagaAction<deleteBlockParams>;
